
// ****************************** Import From AWS Amplify ******************************** //

import '/src/amplify-config';

// ****************************** Import CSS ******************************** //

import "./about.css";

// ****************************** Import Images ******************************** //

import "/src/assets/about/alonzo-truitt-headshot.png"

// **************************** Add Top Nav & Footer ************************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';

// **************************** Flyer Popup Modal ************************** //



// ************ Add Email Signup *************** //